import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/main.scss";
import productData from "../Datas/productData";

function Main() {
  const featuredProducts = productData.slice(0, 4);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const testimonials = [
    {
      id: 1,
      name: "Sarah M.",
      text: "Liiskerlane products are absolutely beautiful and high quality. My dog loves her new collar!",
      rating: 5,
    },
    {
      id: 2,
      name: "James T.",
      text: "Finally found a brand that understands that pet products can be stylish too. Highly recommend!",
      rating: 5,
    },
    {
      id: 3,
      name: "Emma L.",
      text: "The attention to detail is incredible. These are not just functional, they're works of art.",
      rating: 5,
    },
  ];

  const categories = [
    {
      id: 1,
      name: "Collars",
      image: "/main/m2-1.webp",
    },
    {
      id: 2,
      name: "Leashes",
      image: "/main/m2-2.webp",
    },
    {
      id: 3,
      name: "Accessories",
      image: "/main/m2-3.webp",
    },
  ];

  return (
    <div className="main">
      <Header />

      <main className="main-content">
        {/* Hero Section */}
        <section className="hero-section">
          <div className="hero-image-container">
            <img src="/main/main1.png" alt="Hero" className="hero-image" />
            <div className="hero-overlay">
              <h1 className="hero-title">Liiskerlane</h1>
              <p className="hero-subtitle">
                Thoughtfully Designed Pet Products
              </p>
              <Link to="/shop" className="hero-button" onClick={toTop}>
                SHOP NOW
              </Link>
            </div>
          </div>
        </section>

        {/* Announcement Bar */}
        <div className="announcement-ticker">
          <div className="ticker-content">
            {[...Array(5)].map((_, i) => (
              <span key={i}>
                WE INVEST 5% OF EVERY ORDER TO CAUSES YOU CARE ABOUT.
                &nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            ))}
          </div>
        </div>

        {/* Featured Products */}
        <section className="featured-section">
          <h2 className="section-title">New Arrivals</h2>
          <div className="product-grid">
            {featuredProducts.map((product) => (
              <div key={product.id} className="product-card">
                <Link to={`/shopDetails/${product.id}`} onClick={toTop}>
                  <div className="product-image-wrapper">
                    <img src={product.image} alt={product.name} />
                    <div className="quick-add">QUICK ADD</div>
                  </div>
                  <div className="product-info">
                    <p className="product-category">{product.category}</p>
                    <p className="product-price">${product.price}</p>
                    <h3 className="product-name">{product.name}</h3>
                  </div>
                </Link>
              </div>
            ))}
          </div>
          <div className="view-all-container">
            <Link to="/shop" className="view-all-button" onClick={toTop}>
              SHOP ALL NEW ARRIVALS
            </Link>
          </div>
        </section>

        {/* Categories Section */}
        <section className="categories-section">
          <h2 className="categories-title">Shop By Category</h2>
          <div className="categories-grid">
            {categories.map((category) => (
              <div key={category.id} className="category-card">
                <div className="category-image">
                  <img src={category.image} alt={category.name} />
                </div>
                <h3 className="category-name">{category.name}</h3>
                <Link to="/shop" className="category-link" onClick={toTop}>
                  EXPLORE
                </Link>
              </div>
            ))}
          </div>
        </section>

        {/* Story Section */}
        <section className="story-section">
          <div className="story-content">
            <p className="story-label">OUR STORY</p>
            <h2 className="story-title">How we began</h2>
            <p className="story-text">
              We started Liiskerlane because we wanted something a Liiskerlane
              nicer for our dog. We weren't inspired by what was in the market.
              Frankly, we felt most pet products were uninspiring, low quality
              and kitschy.
            </p>
            <p className="story-text">
              We wanted to create a brand that reflects our own aesthetic and
              values. Products that are high quality, thoughtfully designed, and
              ethically produced. A brand that celebrates the bond between
              people and their pets.
            </p>
            <Link to="/about" className="story-link" onClick={toTop}>
              READ OUR STORY
            </Link>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="testimonials-section">
          <h2 className="testimonials-title">What Our Customers Say</h2>
          <div className="testimonials-grid">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="testimonial-card">
                <div className="stars">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <span key={i} className="star">
                      ★
                    </span>
                  ))}
                </div>
                <p className="testimonial-text">"{testimonial.text}"</p>
                <p className="testimonial-author">— {testimonial.name}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Values Section */}
        <section className="values-section">
          <h2 className="values-title">Our Values</h2>
          <div className="values-grid">
            <div className="value-card">
              <h3 className="value-title">Quality</h3>
              <p className="value-text">
                We use only the finest materials and craftsmanship in every
                product.
              </p>
            </div>
            <div className="value-card">
              <h3 className="value-title">Design</h3>
              <p className="value-text">
                Thoughtfully designed products that are both beautiful and
                functional.
              </p>
            </div>
            <div className="value-card">
              <h3 className="value-title">Ethics</h3>
              <p className="value-text">
                We are committed to ethical production and sustainable
                practices.
              </p>
            </div>
            <div className="value-card">
              <h3 className="value-title">Community</h3>
              <p className="value-text">
                Building a community of people who love their pets and care
                about quality.
              </p>
            </div>
          </div>
        </section>

        {/* Newsletter Section */}
        <section className="newsletter-section">
          <div className="newsletter-container">
            <h2 className="newsletter-title">Stay Updated</h2>
            <p className="newsletter-subtitle">
              Subscribe to our newsletter for new products and special offers
            </p>
            <form className="newsletter-form">
              <input type="email" placeholder="Enter your email" required />
              <button type="submit">SUBSCRIBE</button>
            </form>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Main;
